import { render, staticRenderFns } from "./DashboardTherapist.vue?vue&type=template&id=465129b8&scoped=true&"
import script from "./DashboardTherapist.vue?vue&type=script&lang=js&"
export * from "./DashboardTherapist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465129b8",
  null
  
)

export default component.exports